import { del, post, put } from './requests'

const resourcePath = 'api_applications'

export function createApiApplication (apiApplication) {
  return post(resourcePath, { apiApplication })
}

export function updateApiApplication (apiApplication) {
  return put(`${resourcePath}/${apiApplication.id}`, { apiApplication })
}

export function deleteApiApplication (id) {
  return del(`${resourcePath}/${id}`)
}
